import React from 'react'
import Link from 'gatsby-link'
import i18n from '../../i18n'
import { translate } from 'react-i18next'

import { Container, Row, Column } from '../global/grid/grid'

import { FooterWrapper } from './styled-components'

import DominosLogo from '../../static/svgs/dominos-logo.svg'
import P4PLogo from '../../static/svgs/p4p-logo.svg'

const Footer = ({ data, t }) => {
  const gaLogoClicked = () => {
    window.dataLayer.push({
      'event': 'logo:click',
      'nav': 'footer',
      'navItem': 'dominos-logo'
    })
  }

  const langClicked = lng => {
    window.dataLayer.push({
      'event': 'lang:click',
      'langSelect': 'footer',
      'langSelectItem': lng
    })
  }

  const toggle = lng => i18n.changeLanguage(lng)

  const langToggle = (lng) => {
    toggle(lng)
    langClicked(lng)
  }

  return (
    <FooterWrapper>
      <Container>
        <Row margins={false} className='footerContent'>
          <Column className='logoColumn' cw={4}>
            <Link to='/' onClick={gaLogoClicked}>
              <div
                className='logoHolder'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '70px'
                }}>
                <div
                  style={{
                    width: '30px'
                  }}>
                  <DominosLogo />
                </div>
                <div
                  style={{
                    width: '70px',
                    marginLeft: '15px'
                  }}>
                  <P4PLogo />
                </div>
              </div>
            </Link>
          </Column>

          <Column className='langColumn' cw={2}>
            <p>Language:</p>
            <button onClick={() => langToggle('en')}>EN</button>
            <button onClick={() => langToggle('es')}>ES</button>
          </Column>

          <Column
            className='copyrightColumn'
            cw={6}
            style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
            <span className='copyright'>
              {`${t('footer.offerDisclaimer')} ${t('footer.message')} ${t('footer.copyright')}`}
            </span>
          </Column>
        </Row>
      </Container>
    </FooterWrapper>
  )
}

export default translate()(Footer)



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js